exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".less_avatar-module__mg-avatar___t6f0q {\n  font-size: 20px;\n  border-radius: 50%;\n  height: 40px;\n  width: 40px;\n  line-height: 40px;\n  color: #ffffff;\n  text-align: center;\n  padding: 0;\n  font-weight: 600;\n  display: inline-block;\n}\n", ""]);

// exports
exports.locals = {
	"mg-avatar": "less_avatar-module__mg-avatar___t6f0q"
};